/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgApplePay = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M5.654 9.031c-.234.27-.61.484-.984.453-.047-.365.137-.753.351-.993.235-.278.645-.476.977-.491.04.38-.113.754-.344 1.031zm.34.526c-.543-.03-1.008.3-1.266.3-.261 0-.656-.285-1.086-.278a1.61 1.61 0 0 0-1.363.807c-.586.982-.152 2.436.414 3.235.277.396.61.83 1.047.815.414-.015.578-.263 1.078-.263.504 0 .649.263 1.086.255.454-.007.739-.396 1.016-.792.317-.449.446-.886.453-.91-.007-.007-.875-.33-.883-1.305-.007-.814.684-1.202.715-1.225-.39-.563-1-.624-1.21-.64zm3.137-1.104v5.933h.946v-2.028h1.309c1.195 0 2.035-.8 2.035-1.957 0-1.156-.824-1.948-2.004-1.948zm.946.776h1.09c.82 0 1.289.427 1.289 1.176 0 .75-.469 1.18-1.293 1.18h-1.086zm5.07 5.203c.595 0 1.145-.293 1.395-.757h.02v.711h.875v-2.953c0-.856-.703-1.408-1.785-1.408-1.004 0-1.747.56-1.774 1.328h.852c.07-.365.418-.605.894-.605.579 0 .903.263.903.746v.327l-1.18.069c-1.098.064-1.692.502-1.692 1.263 0 .769.614 1.279 1.493 1.279zm.255-.704c-.504 0-.825-.236-.825-.598 0-.373.309-.59.899-.624l1.05-.065v.335c0 .556-.484.952-1.124.952zM18.605 16c.922 0 1.356-.343 1.735-1.382L22 10.082h-.961l-1.113 3.505h-.02l-1.113-3.505h-.989l1.602 4.32-.086.262c-.144.445-.379.617-.797.617-.074 0-.219-.008-.277-.016v.712c.054.015.289.023.36.023z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgApplePay as ApplePay };
